import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="mb-12">
      <div className="flex flex-wrap gap-3">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onSelectCategory(category?.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-xl transition-all ${
              selectedCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-lg shadow-primary/25'
                : 'bg-card border border-border text-muted-foreground hover:bg-muted'
            }`}
          >
            <Icon name={category?.icon} size={18} />
            <span className="text-sm font-medium">{category?.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;